import React, { useState } from 'react';
import { X } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-57">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-58" />
      <div className="relative bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-59">
        <div className="flex items-center justify-between p-6 border-b border-slate-700" data-id="element-60">
          <h2 className="text-xl font-bold text-white" data-id="element-61">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-62">
            <X className="w-5 h-5" data-id="element-63" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-slate-300 text-base leading-relaxed space-y-4" data-id="element-64">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-slate-950 border-t border-slate-800 py-10 px-6" data-id="element-65">
        <div className="max-w-md mx-auto flex flex-col items-center text-center gap-4" data-id="element-66">
          <p className="text-slate-500 text-sm leading-relaxed" data-id="element-67">
            © {new Date().getFullYear()} Programa Ciática SOS. Todos los
            derechos reservados.
          </p>
          <p className="text-slate-600 text-xs leading-relaxed" data-id="element-68">
            Este producto no sustituye el consejo médico profesional.
          </p>
          <div className="flex items-center gap-4 pt-2" data-id="element-69">
            <button onClick={() => setShowPrivacy(true)} className="text-slate-400 hover:text-orange-400 text-sm font-medium transition-colors underline underline-offset-4" data-id="element-70">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-71">|</span>
            <button onClick={() => setShowTerms(true)} className="text-slate-400 hover:text-orange-400 text-sm font-medium transition-colors underline underline-offset-4" data-id="element-72">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-73">
        <p className="text-slate-400 text-sm italic" data-id="element-74">
          Última actualización: Marzo 2026
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-75">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-76">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital. Esto incluye: nombre,
          dirección de correo electrónico y datos de pago (procesados de forma
          segura por nuestro proveedor de pagos).
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-77">
          2. Uso de la Información
        </h3>
        <p data-id="element-78">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-79">
          <li data-id="element-80">Procesar y entregar tu compra</li>
          <li data-id="element-81">Enviarte el acceso al producto digital</li>
          <li data-id="element-82">Comunicarnos contigo sobre tu pedido</li>
          <li data-id="element-83">Cumplir con obligaciones legales</li>
        </ul>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-84">
          3. Protección de Datos
        </h3>
        <p data-id="element-85">
          Utilizamos encriptación SSL de 256 bits para proteger toda la
          información transmitida. No almacenamos datos de tarjetas de crédito
          en nuestros servidores. Los pagos son procesados por plataformas
          certificadas con los más altos estándares de seguridad.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-86">
          4. Compartir Información
        </h3>
        <p data-id="element-87">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cuando
          lo requiera la ley.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-88">5. Cookies</h3>
        <p data-id="element-89">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-90">6. Tus Derechos</h3>
        <p data-id="element-91">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, contáctanos por
          correo electrónico.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-92">
          7. Cambios a esta Política
        </h3>
        <p data-id="element-93">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta página con la fecha de
          actualización correspondiente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-94">
        <p className="text-slate-400 text-sm italic" data-id="element-95">
          Última actualización: Marzo 2026
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-96">
          1. Producto Digital
        </h3>
        <p data-id="element-97">
          Ciática SOS es un manual digital en formato PDF con contenido
          educativo e informativo. Al realizar la compra, recibirás acceso
          inmediato al material descargable.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-98">
          2. Aviso Médico Importante
        </h3>
        <p data-id="element-99">
          Este producto es de carácter informativo y educativo.{' '}
          <strong className="text-white" data-id="element-100">
            No sustituye el consejo médico profesional, diagnóstico ni
            tratamiento.
          </strong>{' '}
          Siempre consulta con un profesional de la salud calificado antes de
          iniciar cualquier programa de ejercicios o protocolo de salud. Si
          experimentas síntomas de emergencia (pérdida de control de esfínteres,
          debilidad severa), busca atención médica inmediata.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-101">3. Resultados</h3>
        <p data-id="element-102">
          Los resultados pueden variar de persona a persona. Los testimonios y
          ejemplos mencionados no garantizan resultados específicos. Tu
          experiencia dependerá de múltiples factores individuales.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-103">
          4. Política de Reembolso
        </h3>
        <p data-id="element-104">
          Ofrecemos una garantía de satisfacción. Si no estás satisfecho con el
          producto, puedes solicitar un reembolso completo contactándonos por
          correo electrónico. El reembolso se procesará sin preguntas.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-105">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-106">
          Todo el contenido de Ciática SOS, incluyendo textos, ilustraciones y
          metodología, está protegido por derechos de autor. Queda prohibida la
          reproducción, distribución o reventa del material sin autorización
          expresa.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-107">6. Uso Permitido</h3>
        <p data-id="element-108">
          La licencia de compra es personal e intransferible. El material es
          para tu uso individual y no puede ser compartido, revendido ni
          distribuido a terceros.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-109">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-110">
          En la máxima medida permitida por la ley, no seremos responsables por
          daños directos, indirectos, incidentales o consecuentes derivados del
          uso de este producto. El usuario asume toda la responsabilidad por el
          uso del material.
        </p>

        <h3 className="text-lg font-bold text-white pt-2" data-id="element-111">8. Ley Aplicable</h3>
        <p data-id="element-112">
          Estos términos se rigen por las leyes aplicables de los Estados Unidos
          de América. Cualquier disputa será resuelta en los tribunales
          competentes.
        </p>
      </Modal>
    </>;
}